import React, {useEffect, useRef, useState} from 'react';
import {connect, useDispatch, useSelector} from 'react-redux';
import {
  RadioGroup,
  FormControlLabel,
  Radio,
  Divider,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '@material-ui/core';

import {ExpandMore as ExpandMoreIcon, RecentActors} from '@material-ui/icons';

import {makeStyles} from '@material-ui/core';
import * as actions from '../../../redux/actions/patient/patient';
import {
  selectCaseStatus,
  selectCurrentPageNumber,
  selectFetchPatients,
  selectPatientStatus,
  selectPortalStatuses,
  selectRowPerPage,
  selectSortBy,
} from 'redux/reducers/patient/patient';

const FilterAndSortPanel = (props) => {
  const customClasses = makeStyles((theme) => ({
    filterAndSortPanel: {
      display: 'flex',
      flexDirection: 'column',
      paddingLeft: 10,
      paddingRight: 10,
      textWrap: 'nowrap',
    },
    selectList: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      color: 'black',
    },
    selectionField: {
      width: '270px',
      marginTop: '10px',
      marginLeft: '-12px',
      borderRadius: '4px',
      height: 40,
      border: 'solid #F4F3F3 1px',
    },
    inputLabel: {
      fontSize: 14,
    },

    radioGroup: {
      marginLeft: -10,
      paddingLeft: 0,
    },

    icon: {
      marginRight: 5,
      flexShrink: 0,
    },

    alertText: {
      color: 'red',
      fontWeight: 'bold',
    },
  }));
  const classes = customClasses();

  // const [caseStatus, setCaseStatus] = useState(props.caseStatus);
  const [expanded, setExpanded] = useState(true);

  const handleAccordionClick = () => {
    setExpanded(!expanded);
  };

  const handleSelectionChange = (event) => {
    const {name, value} = event.target;

    if (name === 'status') {
      // setCaseStatus(value);

      props.setCaseStatus(value);
      if (!props.fetchPatients) {
        props.setFetchPatients(true);
      }
    }
  };

  const StatusRadioItem = (props) => {
    const {statusData} = props;
    const {status, count, lastUpdated, lastVisited} = statusData;

    return (
      <FormControlLabel
        value={status}
        control={<Radio size='medium' />}
        className={classes.inputLabel}
        label={
          <Typography className={classes.inputLabel}>
            <span>{status || 'helo'}</span>
            <span
              className={
                count > 0 && lastUpdated > lastVisited ? classes.alertText : ''
              }>
              {` (${count})`}
            </span>
          </Typography>
        }
      />
    );
  };

  // const fetchStatusCount = () => {
  //   ApiConfig.patient()
  //     .fetchPatientStatusCount()
  //     .then((res) => {
  //       setStatusCountList(res.data);
  //     })
  //     .catch((err) => {
  //       console.log(err.message);
  //     });
  // };

  const timeoutRef = useRef(null);

  const poll = () => {
    props.fetchPortalStatusCount();
    timeoutRef.current = setTimeout(poll, 10000); // Schedule next run in 10 seconds
  };

  const startPolling = () => {
    if (timeoutRef.current === null) {
      poll();
    }
  };

  const stopPolling = () => {
    if (timeoutRef.current !== null) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
  };

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        startPolling();
      } else {
        stopPolling();
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    if (document.visibilityState === 'visible') {
      startPolling();
    }

    return () => {
      stopPolling();
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  return (
    <div className={classes.filterAndSortPanel}>
      <Divider orientation='horizontal' variant='middle' />

      <Accordion expanded={expanded}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls='panel1bh-content'
          id='panel1bh-header'
          onClick={handleAccordionClick}>
          <RecentActors className={classes.icon}></RecentActors>
          {expanded ? (
            <Typography sx={{width: '33%', flexShrink: 1}}>
              Case Status &nbsp;
            </Typography>
          ) : (
            <Typography
              style={{flexShrink: 1, textWrap: 'wrap'}}
              sx={{width: '33%', flexShrink: 1}}>
              {`${props.caseStatus} (${
                props.portalStatuses.find(
                  (item) => item.status === props.caseStatus,
                )?.count ?? 0
              })`}
            </Typography>
          )}
        </AccordionSummary>
        <AccordionDetails>
          <RadioGroup
            row
            aria-label='status'
            name='status'
            value={props.caseStatus}
            defaultValue={props.caseStatus}
            onChange={handleSelectionChange}
            className={classes.radioGroup}>
            {props.portalStatuses.map((statusData, index) => (
              <StatusRadioItem key={index} statusData={statusData} />
            ))}
          </RadioGroup>
        </AccordionDetails>
      </Accordion>
    </div>
  );
};

const mapStateToProps = (state) => ({
  sortBy: selectSortBy(state),
  caseStatus: selectCaseStatus(state),
  patientStatus: selectPatientStatus(state),
  currentPageNumber: selectCurrentPageNumber(state),
  rowPerPage: selectRowPerPage(state),
  fetchPatients: selectFetchPatients(state),
  portalStatuses: selectPortalStatuses(state),
});

const mapActionToProps = {
  fetchFiltered: actions.fetchFiltered,
  setCaseStatus: actions.setCaseStatus,
  setSortBy: actions.setSortBy,
  setFetchPatients: actions.setFetchPatients,
  fetchPortalStatusCount: actions.fetchPortalStatusCount,
};

export default connect(mapStateToProps, mapActionToProps)(FilterAndSortPanel);
